<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      title=""
      width="30%"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl Add Products text-white">
          {{ AddEdit }} Tags
        </h3></template
      >
      <div>
        <el-form
          role="form"
          class=""
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <div>
            <p class="text-lg font-semibold text-black mb-0">Tags Name</p>
            <el-form-item prop="tagname">
              <el-input
                placeholder="Tags Name"
                v-model="ruleForm.tagname"
                maxlength="50"
                class="w-full mt-2"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-black mb-0">Category</p>
            <el-form-item prop="categoryName">
              <el-select
                multiple
                filterable
                allow-create
                default-first-option
                v-model="ruleForm.categoryName"
                placeholder="Select"
                class="w-full mt-1"
              >
                <el-option
                  v-for="(item, index) in EcomCategory"
                  :key="`${item._id}+${index}`"
                  :label="item.categoryName"
                  :value="item.categoryName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="flex justify-center mt-8">
            <vs-button
              @click="handleSubmit('ruleForm')"
              class="rounded-lg w-full border-0 col-purple font-semibold fsize14 md:py-3 py-3 px-10 sm-fsize14"
            >
              Submit
            </vs-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Tags
          </h2>
        </div>
      </div>
    </div>
    <div class="menucontrol-scroll fixed-top">
      <div class="py-6 px-8">
        <div>
          <div class="flex justify-end items-center w-full gap-2">
            <el-input
              v-model="search"
              maxlength="50"
              placeholder="Search here..."
              class="w-3/2"
            />
            <vs-button
              @click="handleAddEdit('Add')"
              variant="primary"
              class="border-0 font-semibold w-1/5 rounded-lg lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
            >
              Add Tags
            </vs-button>
          </div>
          <div class="">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
              header-row-class-name="thead-light table-th-color"
            >
              <el-table-column
                :index="indexmethod"
                type="index"
                label="Sr.no"
                width="80"
              ></el-table-column>
              <el-table-column prop="city" label="Tag name" min-width="400px">
                <template v-slot="{ row }">
                  <P class="text-gray">{{ row.tagName }}</P>
                </template>
              </el-table-column>
              <el-table-column prop="city" label="Category" min-width="200px">
                <template v-slot="{ row }">
                  <div class="flex gap-2 flex-wrap">
                    <el-tag
                      v-for="(item, index) in row.categoryId"
                      :key="`${item._id}+${index}`"
                      class="text-gray rounded-full"
                      type="success"
                      >{{ item.categoryName }}</el-tag
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="city"
                label="No of Product"
                min-width="100px"
              >
                <template v-slot="{ row }">
                  <P class="text-gray">{{ row.productId.length }}</P>
                </template>
              </el-table-column>
              <el-table-column prop="city" label="Actions" min-width="90px">
                <template v-slot="{ row }">
                  <div class="flex items-center">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-4 h-4"
                      class="cursor-pointer"
                      @click="handleAddEdit('Edit', row)"
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="w-full flex justify-end mt-6" v-if="totalRows > 0">
            <el-pagination
              background
              layout="prev,pager,next"
              :total="totalRows"
              :page-size="perPage"
              @current-change="setPage"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div class="">
        <!-- <div>
          <div class="">
            <div class="mt-6">
              <div class="">
                <el-table
                  :data="tableData"
                  border
                  style="width: 100%"
                  height="490"
                  class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
                  header-row-class-name="thead-light table-th-color"
                >
                  <el-table-column
                    prop="city"
                    label="Tag name"
                    min-width="400px"
                  >
                    <template slot-scope="">
                      <P class="text-gray">Raj Shetye</P>
                    </template>
                  </el-table-column>

                  <el-table-column prop="city" label="Actions" min-width="40px">
                    <template slot-scope="">
                      <div class="flex gap-1 items-center">
                        <feather-icon
                          icon="EditIcon"
                          svgClasses="w-4 h-4"
                          class="cursor-pointer"
                          @click="centerDialogVisibleg = true"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="w-4 h-4"
                          class="cursor-pointer"
                        />
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="w-full flex justify-end mt-6">
                  <b-pagination
                    v-model="currentPage"
                    pills
                    :total-rows="rows"
                    size="sm"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
import { mapState } from "vuex";
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",
      tagname: "",
      categoryName: [],
      tableData: [],
      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,

      AddEdit: "Add",
      tagId: "",

      ruleForm: {
        tagname: "",
        categoryName: [],
      },
      rules: {
        tagname: [
          {
            required: true,
            message: "Please Enter Tag Name",
            trigger: "blur",
          },
        ],
        categoryName: [
          {
            type: "array",
            required: true,
            message: "Please Select Categories",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    async currentPage() {
      await this.getAllTag();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getAllTag();
      }, 500),
    },
  },
  methods: {
    handleAddEdit(name, data = {}) {
      if (name === "Add") {
        this.resetForm("ruleForm");
      } else if (name === "Edit") {
        this.tagId = data._id ? data._id : "";
        this.ruleForm.tagname = data.tagName ? data.tagName : "";
        this.ruleForm.categoryName =
          data.categoryId && data.categoryId.length > 0
            ? data.categoryId.map((cat) => cat.categoryName)
            : [];
      }
      this.AddEdit = name;
      this.drawer = true;
    },
    handleSubmit(formName) {
      this.ruleForm.tagname = this.ruleForm.tagname.trim();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addTags();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    handleClose() {
      this.drawer = false;
      this.resetForm("ruleForm");
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.ruleForm.tagname = "";
      this.ruleForm.categoryName = [];
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async addTags() {
      let payload = {
        tagName: this.ruleForm.tagname,
        category: this.ruleForm.categoryName,
      };

      if (this.AddEdit === "Edit" && this.tagId) {
        Object.assign(payload, { tagId: this.tagId });
      }

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let createTag;
        if (this.AddEdit === "Add") {
          createTag = await this.$store.dispatch("tags/addTags", payload);
        } else if (this.AddEdit === "Edit") {
          createTag = await this.$store.dispatch("tags/editTags", payload);
        }

        if (createTag.code === 200) {
          // console.log(createTag);
          loader.close();
          this.handleClose();
          await this.$swal({
            title: `Tag ${
              this.AddEdit === "Add" ? "Created" : "Updated"
            } Successfully!`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.resetForm("ruleForm");
          this.getAllTag();
        }
        loader.close();
      } catch (error) {
        loader.close();
        if (error.response.data.code !== 500) {
          this.$notify.error({
            message: `${
              error.response.data.message
                ? error.response.data.message
                : "Something went wrong"
            }`,
            position: "bottom-right",
          });
        }
      }
    },
    async getTags() {
      await this.$store.dispatch("tags/getTags");
    },
    async getCategory() {
      await this.$store.dispatch("EcomCategory/getCategory");
    },

    async getAllTag() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getAllTag = await this.$store.dispatch(
          "tags/getAllTags",
          payload
        );
        // console.log(getAllTag);
        loader.close();
        if (getAllTag.code === 200) {
          this.totalRows = this.allTags.totalCount;
          this.tableData = this.allTags.result;
        }
      } catch (error) {
        loader.close();
      }
    },
    setPage(page) {
      this.currentPage = page;
    },
  },
  mounted() {
    this.getAllTag();
    // this.getTags();
    this.getCategory();
  },
  computed: {
    ...mapState("tags", ["tagsDetails"]),
    ...mapState("tags", ["allTags"]),
    ...mapState("EcomCategory", ["EcomCategory"]),
  },
};
</script>
